<template>
  <div class="search">
    <van-nav-bar :title="lang.toptitle" left-arrow @click-left="clickLeft()" class="nav_bar" />
    <van-search :placeholder="lang.search" v-model="searchKey" show-action :clearable="false">
      <div slot="action" @click="searchShow = false">{{ lang.cancel }}</div>
    </van-search>
    <!-- 列表匹配 -->
    <van-list v-model="loading" :finished="finished" @load="onLoad()" v-if="searchShow">
      <ul class="searchul">
        <li v-for="(item, idx) in Addlist" :key="idx" @click="goStep(item)">
          <svg class="icon icon_li" aria-hidden="true">
            <use xlink:href="#icon-sousuo-daohanglanx"></use>
          </svg>
          <span class="van-ellipsis ellpls"> {{ item.gscopeNameWithCulture == null ? '' : `${item.gscopeNameWithCulture} - ` }} {{ item.displayEstateNameWithCulture }} </span>
        </li>
      </ul>
    </van-list>
    <!-- 手动输入 入口 -->
    <div class="searchAddress" v-else>
      <div class="search" @click="manualsearchShowEven">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-sousuo-daohanglanx"></use>
        </svg>
        <span class="searchText">{{ lang.inputEstateOrBuildingName }}</span>
      </div>
      <p>{{ lang.manuallyEnterBuilding }}</p>
    </div>
    <van-popup v-model="ManualsearchShow" position="top" :overlay="false" class="searchShow">
      <van-nav-bar :title="lang.inputEstateOrBuildingName" left-arrow @click-left="closeManualsearch" :right-text="lang.confirm" @click-right="confrimName" />
      <van-cell-group class="space">
        <van-cell :title="lang.region" is-link @click="addressShow = true" :value="gscopeCodeText" required />
        <!-- 弹出层--地址选择 -->
        <van-popup position="bottom" v-model="addressShow" class="choose">
          <div class="district">
            <!-- 省 -->
            <ul :class="['province', { provinceMin: areaList.city.length > 0 }]">
              <li v-for="(item, index) in areaList.province" :key="index" :class="{ selected: item.gscopeCode === areaList.selectprovince }" @click="changeArea('province', item)">
                {{ item.gscopeNameWithCulture }}
              </li>
            </ul>
            <!-- 市 -->
            <ul v-if="areaList.city.length" class="city">
              <li v-for="(item, index) in areaList.city" :key="index" :class="{ selected: item.gscopeCode === areaList.selectcity }" @click="changeArea('city', item)">
                {{ item.gscopeNameWithCulture }}
              </li>
            </ul>
            <!-- 区 -->
            <ul v-if="areaList.area.length" class="area">
              <li v-for="(item, index) in areaList.area" :key="index" :class="{ selected: item.gscopeCode === areaList.selectarea }" @click="changeArea('area', item)">
                {{ item.gscopeNameWithCulture }}
              </li>
            </ul>
          </div>
          <div class="btn-area">
            <p @click="reset">{{ lang.clearAll }}</p>
            <van-button type="danger" @click="verify">{{ lang.confirm }} </van-button>
          </div>
        </van-popup>
        <van-field v-model="PropertyInfo.estateName" required :label="lang.houseChiName" input-align="right" type="text" maxlength="30" />
        <van-field v-model="PropertyInfo.estateNameEN" :label="lang.houseEngName" input-align="right" type="text" maxlength="60" />
      </van-cell-group>
      <p class="checked">{{ lang.checked }}</p>
    </van-popup>
  </div>
</template>

<script>
import { Area } from 'vant';
import { clearInterval, setInterval } from 'timers';
import { mapState, mapMutations } from 'vuex';
import lang from './../../../common/language/post';
import post from './../../../common/js/post';
export default {
  data() {
    return {
      lang,
      query: '',
      searchShow: false,
      ManualsearchShow: false,
      addressShow: false,
      childrenShow: false,
      searchKey: '',
      Addlist: [],
      pageIndex: 1,
      count: 0,
      gscopeCodeText: '',
      gscopeNameWithCulture: '',
      areaChildren: [],
      PropertyInfo: {
        estateName: '',
        estateNameEN: '',
        estateAddress: '',
        estateAddressEN: '',
        gscopeCode: '',
      },
      // 手动选择区域
      areaList: {
        province: [],
        city: [],
        area: [],
        selectprovince: -1,
        selectcity: -1,
        selectarea: -1,
      },
      loading: false,
      finished: true,
      isload: false,
      flag: true,
      estateId: '',
      platImgCode: '',
    };
  },
  metaInfo() {
    return {
      title: this.lang.toptitle,
    };
  },
  created() {
    // 获取区域数据
    this.getAddressData();
    if (this.store.state.estateInfo.estateID == 0) {
      this.PropertyInfo = this.store.state.estateInfo;
      this.gscopeCodeText = this.PropertyInfo.gscopeCodeText || '';
    }
  },
  watch: {
    searchKey(key) {
      if (key.trim()) {
        if (this.flag) {
          this.flag = false;
          setTimeout(() => {
            this.Addlist = [];
            this.init();
            this.searchShow = true; //搜索列表展示
            this.flag = true;
          }, 1000);
        }
      } else {
        this.Addlist = [];
        return (this.loading = false);
      }
    },
  },
  methods: {
    clickLeft() {
      this.store.commit('setIsBackFlag', true);
      this.$router.go(-1);
    },
    ...mapMutations(['setProperty']),
    // 手动输入地址 -- 取消按钮 重置选项状态
    manualsearchShowEven() {
      if (this.store.state.propertyCategory) {
        this.ManualsearchShow = true;
      }
    },
    reset() {
      this.addressShow = false;
      this.gscopeCodeText = '';
      this.areaList.city = [];
      this.areaList.area = [];
      this.areaList.selectprovince = '';
      this.areaList.selectcity = '';
      this.areaList.selectarea = '';
      this.PropertyInfo.gscopeCode = '';
    },
    // 手动输入地址 -- 确认按钮
    verify() {
      if (!this.PropertyInfo.gscopeCode) {
        this.$notify(lang.requireAddress.region);
        return;
      } else {
        this.addressShow = false;
      }
    },
    // 搜索 -- 下拉加载
    onLoad(page) {
      this.pageIndex++;
      this.axios
        .post(this.pub.getApi().SearchEstateSuggester, {
          estateSrc: this.$route.query.PropertyCategory ? this.$route.query.PropertyCategory : '',
          keywords: this.searchKey.trim(),
          pageIndex: this.pageIndex,
          parentEstateId: 0,
          pageCount: 15,
        })
        .then((res) => {
          if (res.data.code == 0 && res.data.result) {
            this.count = res.data.result.count;
            this.Addlist = this.Addlist.concat(res.data.result.data);
            this.loading = false;
            if (this.Addlist.length >= this.count) {
              this.finished = true;
            }
          }
        });
    },
    // 获取地区
    getAddressData() {
      this.axios.get(this.pub.getApi().GetGscope).then((res) => {
        if (res.data.code === 0 && res.data.result) {
          this.areaList.province = res.data.result;
        }
      });
    },

    closeManualsearch() {
      this.ManualsearchShow = false;
    },
    // 手动输入地址
    confrimName() {
      if (this.validate_required()) {
        this.ManualsearchShow = false; // 关闭手动搜索地址
        this.store.commit('setEstate', {
          buildingAge: '',
          estateID: 0,
          parentEstateID: '',
          parentID: '',
          estateAddress: '',
          estateAddressEN: '',
          estateAddressWithCulture: '',
          gscopeCode: this.PropertyInfo.gscopeCode, //板块id
          estateName: this.PropertyInfo.estateName, // 屋苑名称
          estateNameEN: this.PropertyInfo.estateNameEN, // 屋苑名称英文
          gscopeCodeText: this.gscopeCodeText,
          estateSrcList: [1,2,3,4,5],
          gscopeNameWithCulture: this.gscopeNameWithCulture ? this.gscopeNameWithCulture : this.PropertyInfo.gscopeNameWithCulture ? this.PropertyInfo.gscopeNameWithCulture : '',
        });
        this.store.commit('setPhaseSelectText', '');
        this.store.commit('setPhaseWarpData', '');
        this.store.commit('setBuildSelectText', '');
        this.store.commit('setFloorSelectText', '');
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setUnitFloorSelctText', '');
        this.store.commit('setBuildSelectId', '');
        this.store.commit('setSelectFloorData', '');
        this.store.commit('setPhaseData', '');
        this.store.commit('setEstateData', '');
        this.store.commit('setUnitFloorData', '');
        this.store.commit('setIsBackFlag', false);
        this.store.commit('setBuildNumByPhase', []);
        this.store.commit('setBuildNum', []);
        this.store.commit('setPhase', []);
        window.stop();
        this.$router.go(-1);
      }
    },
    // 搜索选择的地址
    goStep(item) {
      // 根据楼盘ID 获取单个楼盘信息
      this.axios
        .get(this.pub.getApi().GetEstate, {
          params: {
            estateId: item.estateID,
          },
        })
        .then((res) => {
          if (res.data.code == 0 && res.data.result) {
            let HouseInfo = res.data.result;
            this.store.commit('setEstate', {
              buildingAge: HouseInfo.buildingAge > 0 ? HouseInfo.buildingAge : '',
              estateType: HouseInfo.estateType,
              estateID: HouseInfo.estateID,
              parentEstateID: HouseInfo.estateID,
              parentID: HouseInfo.estateID,
              estateName: HouseInfo.estateName, // 屋苑名称
              estateNameEN: HouseInfo.estateNameEN, // 屋苑名称英文
              estateAddressWithCulture: HouseInfo.estateAddressWithCulture,
              estateAddress: `${HouseInfo.detailAddressWithCulture == null ? '' : HouseInfo.detailAddressWithCulture}`, // 详细地址
              estateAddressEN: `${HouseInfo.detailAddressWithCulture == null ? '' : HouseInfo.detailAddressWithCulture}`, // 详细地址
              gscopeCode: HouseInfo.gscopeCode, //板块id
              gscopeCodeText: HouseInfo.gscopeNameWithCulture,
              gscopeNameWithCulture: HouseInfo.gscopeNameWithCulture,
              estateSrcList: HouseInfo.estateSrcList
            });
            // 新版获取期数 座数等接口(搜索的时候调用该接口)
            this.store.commit('setPhaseSelectText', '');
            this.store.commit('setBuildSelectText', '');
            this.store.commit('setFloorSelectText', '');
            this.store.commit('setroomNoWithCulture', '');
            this.store.commit('setUnitFloorSelctText', '');
            this.store.commit('setSelectFloorData', '');
            this.store.commit('setBuildSelectId', '');
            this.store.commit('setPhaseWarpData', '');
            this.store.commit('setPhase', []);
            this.store.commit('setPhaseData', '');
            this.store.commit('setBuildNumByPhase', []);
            this.store.commit('setBuildNum', []);
            this.store.commit('setUnitFloorData', '');
            this.getPhasesAndBuildingForPublish(HouseInfo.estateID);
            // if (HouseInfo.estateType == 'bigest') {
            //   this.getPhase(HouseInfo.estateID);
            // } else {
            //   window.stop();
            //   this.store.commit('setPhase', []);
            //   this.$router.go(-1);
            //   // console.log('直接返回上一页');
            // }
          }
        });
    },
    // 切换区域
    changeArea(attr, value) {
      // 记录当前选中值
      this.areaList[`select${attr}`] = value.gscopeCode;
      // 如果是省给区域复制
      if (attr == 'province') {
        this.areaList.city = value.children;
        // 清空市 区的选中状态
        this.areaList.selectcity = '';
        this.areaList.selectarea = '';
      }
      if (attr == 'city') {
        this.areaList.area = value.children;
        this.gscopeCodeText = value.gscopeNameWithCulture;
        this.areaList.selectarea = '';
      }
      if (attr == 'area') {
        this.gscopeCodeText += '-' + value.gscopeNameWithCulture;
        this.gscopeNameWithCulture = value.gscopeNameWithCulture;
        this.PropertyInfo.gscopeCode = value.gscopeCode;
      }
    },
    // 搜索请求
    init() {
      this.pageIndex = 1;
      this.axios
        .post(this.pub.getApi().SearchEstateSuggester, {
          estateSrc: this.$route.query.PropertyCategory ? this.$route.query.PropertyCategory : '',
          keywords: this.searchKey.trim(),
          pageIndex: this.pageIndex,
          pageCount: 15,
          parentEstateId: 0,
        })
        .then((res) => {
          if (res.data.code == 0 && res.data.result) {
            this.count = res.data.result.count;
            this.Addlist = res.data.result.data;
            this.loading = false;
            if (this.Addlist.length >= this.count) {
              this.finished = true;
            } else {
              this.finished = false;
            }
          }
        });
    },
    // 校验
    validate_required() {
      if (!this.gscopeCodeText || !this.gscopeCodeText.trim().length) {
        this.$notify(lang.requireAddress.region);
        return;
      }
      if (!this.PropertyInfo.estateName.trim().length && !this.PropertyInfo.estateNameEN.trim().length) {
        this.$notify(lang.requireAddress.houseChiName);
        return;
      }
      return true;
    },
    getPhasesAndBuildingForPublish(estateId) {
      this.axios
        .get(this.pub.getApi().GetPhasesAndBuildingForPublish, {
          params: {
            estateId: estateId,
            categoryId: this.$route.query.PropertyCategory ? this.$route.query.PropertyCategory : ''
          },
        })
        .then((res) => {
          if (res.data.code == 0 && res.data.result) {
            this.store.commit('setPhase', res.data.result.estatePhases);
            this.store.commit('setBuildNum', res.data.result.buildingResponses);
            this.store.commit('setEstateData', res.data.result.estate);
            if (this.$route.query.PropertyCategory == 1 && !res.data.result.estatePhases.isCutomadded) {
              // 如果期数选项只有一个，那么自动填入
              if (res.data.result.estatePhases && res.data.result.estatePhases.length == 1) {
                this.store.commit('setPhaseSelectText', res.data.result.estatePhases[0].phaseWithCulture);
                this.store.commit('setPhaseWarpData', res.data.result.estatePhases[0].phaseWithCulture);
                this.store.commit('setPhaseData', res.data.result.estatePhases[0]);
                this.store.commit('setBuildNumByPhase', res.data.result.buildingResponses);
              }
              if (res.data.result.buildingResponses && res.data.result.buildingResponses.length == 1) {
                this.store.commit('setBuildSelectText', res.data.result.buildingResponses[0].phaseAndBuildingNameWithCulture);
                this.store.commit('setBuildSelectId', res.data.result.buildingResponses[0]);
                if (res.data.result.estatePhases && res.data.result.estatePhases.length > 1) {
                  let phaseByBuildName = res.data.result.estatePhases.filter((item) => {
                    return item.estateID == res.data.result.buildingResponses[0].estateID;
                  });
                  this.store.commit('setPhaseData', phaseByBuildName);
                  this.store.commit('setPhaseSelectText', phaseByBuildName.length > 0 ? phaseByBuildName[0].phaseAndBuildingNameWithCulture : '');
                  this.store.commit('setPhaseWarpData', phaseByBuildName.length > 0 ? phaseByBuildName[0].phaseAndBuildingNameWithCulture : '');
                }
                if (res.data.result.estatePhases && res.data.result.estatePhases.length == 0) {
                  this.store.commit('setPhaseData', '');
                  this.store.commit('setPhaseSelectText', '');
                  this.store.commit('setPhaseWarpData', '');
                }
                this.axios
                  .get(this.pub.getApi().GetBuildingFloorPublish, {
                    params: {
                      buildingId: res.data.result.buildingResponses[0].buildingID,
                    },
                  })
                  .then((res) => {
                    if (res.data.code == 0 && res.data.result) {
                      if (res.data.result.length > 0) {
                        this.store.commit('setFloorData', { title: this.lang.height1, children: res.data.result });
                      } else {
                        this.store.commit('setFloorData', { title: this.lang.height1, children: [] });
                      }

                      if (res.data.result.length == 1) {
                        this.store.commit('setFloorSelectText', res.data.result[0].floorNameWithCulture);
                        this.store.commit('setSelectFloorData', res.data.result[0]);
                        if (res.data.result[0].unitFloor > 0) {
                          this.store.commit('setUnitFloorSelctText', res.data.result[0].unitFloorWithCulture);
                        }
                      }
                    }
                  });
              }
            }
            this.store.commit('setIsBackFlag', false);
            window.stop();
            this.$router.go(-1);
          }
        });
    },
    // 获取期数盘信息存储vuex
    getPhase(EstateSrc) {
      this.axios
        .post(this.pub.getApi().SearchEstateSuggester, {
          estateSrc: this.$route.query.PropertyCategory ? this.$route.query.PropertyCategory : '',
          order: 'PhaseSequenceAsc', // 按期数排序
          pageIndex: 1,
          pageCount: 20,
        })
        .then((res) => {
          if (res.data.code == 0 && res.data.result) {
            this.store.commit('setPhase', res.data.result.data);
            window.stop();
            this.$router.go(-1);
          }
        });
    },
  },
  components: {
    [Area.name]: Area,
  },
};
</script>

<style lang="scss" scoped>
.choose {
  height: 90%;
  border-radius: 5px 5px 0px 0px;
  /deep/.van-picker {
    margin-top: 20px;
    .van-hairline--top-bottom::after {
      border: none;
    }
    .van-picker__toolbar {
      .van-picker__title {
        font-size: 17px;
        font-weight: 600;
        text-align: left;
        color: #333333;
        line-height: 24px;
        margin-left: 20px;
      }
      .van-picker__cancel,
      .van-picker__confirm {
        display: none;
      }
    }
    .van-picker__columns {
      max-height: 500px !important;
      height: 500px !important;
      .van-picker-column {
        height: 100% !important;
      }
      .van-hairline--top-bottom,
      .van-picker__frame {
        border: 1px solid #eee;
        border-left: 3px solid #ed1818;
        top: 110px;
      }
    }
  }
  .btn-area {
    display: flex;
    justify-content: space-around;
    padding: 10px;
    height: 64px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 44px;
    p {
      font-size: 15px;
      font-weight: 400;
      color: #666666;
    }
    .van-button--danger {
      margin: 0;
      text-align: center;
      width: 210px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
.ellpls {
  display: inline-block;
  width: 98%;
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
/deep/ .van-cell__title {
  text-align: left;
}
/deep/ .van-field__label {
  max-width: 150px;
}
.space {
  margin-top: 17px;
}
.checked {
  font-size: 12px;
  color: #999999;
  text-align: left;
  height: 44px;
  line-height: 44px;
  margin-left: 16px;
}
.cent_sign {
  font-size: 10px;
  text-align: left;
  margin: 10px;
  color: #b2b2b2;
}
.search {
  height: 100%;
  background-color: #f5f6f7;
}
.nav_bar {
  border: 0;
}
.searchShow {
  width: 100%;
  height: 100%;
  background-color: #f5f6f7;
  .top_search {
    position: relative;
    border-bottom: 1px solid #ccc;
  }
  .icon {
    position: absolute;
    right: 45px;
    font-size: 30px;
    top: 30px;
    transform: translateY(-50%);
  }
}
.searchul {
  background-color: #fff;
  .icon_li {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    font-size: 20px;
  }
  li {
    position: relative;
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #eeeeee;
    text-align: left;
    font-size: 14px;
    color: #333333;
    padding-left: 43px;
    box-sizing: border-box;
  }
}
.searchAddress {
  font-size: 14px;
  color: #333333;
  margin-top: 130px;
  .search {
    // width: 200px;
    display: inline-block;
    box-sizing: border-box;
    height: 32px;
    line-height: 32px;
    border: 1px solid #b2b2b2;
    margin: 10px auto;
    font-weight: 600;
    position: relative;
    padding: 0 10px;
    box-sizing: border-box;
    .icon {
      color: #b1b1b3;
      font-size: 18px;
      position: absolute;
      left: 10px;
      top: 7px;
      color: #b1b1b3;
    }
    .searchText {
      margin-left: 22px;
    }
  }
  p {
    padding: 0 15px;
    font-size: 12px;
    color: #3f3f3f;
    line-height: 17px;
  }
}
.district {
  height: 80%;
  overflow: scroll;
  display: flex;
  ul {
    justify-content: space-between;
    li {
      height: 44px;
      line-height: 44px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 15px;
      font-weight: 400;
      text-align: left;
      color: #333333;
      padding-left: 5px;
      text-align: center;
    }
    .selected {
      font-weight: 500;
      color: #ed1818;
    }
  }
  .province {
    width: 100%;
  }
  .provinceMin {
    width: 35%;
  }
  .city {
    width: 70%;
    overflow: scroll;
  }
  .city::-webkit-scrollbar {
    width: 0 !important;
  }

  .area {
    width: 35%;
  }
}
/deep/ .van-cell__value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
.van-notify {
  z-index: 9999 !important;
}
</style>
